var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Meter',{attrs:{"title":"Total contests","result":_vm.result,"imageSrc":require('@/assets/red-circle.svg')}})}
var staticRenderFns = []

export { render, staticRenderFns }